import {Customer} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardProperty,
} from "@flexinet/ui-components";
import { Stack } from '@mantine/core';
import {useAllowedItems} from "../../../hooks/useAllowedProperties.ts";
import { StripeCustomerButtons } from '../buttons/StripeCustomerButtons';
import { useState, useEffect } from 'react';

export const BillingProviderPropertyCard = ({record, onRecordUpdate}: { record: Customer, onRecordUpdate?: (updates: Partial<Customer>) => void }) => {
    const [customer, setCustomer] = useState(record);

    useEffect(() => {
        setCustomer(record);
    }, [record]);

    const properties = [
        {
            label: 'Billing Provider',
            value: customer.billingInfo?.billingProviderId || '-',
            span: 12,
        }, {
            label: 'Billing Provider Record ID',
            value: customer.billingInfo?.billingProviderRecordId || '-',
            decorator: (value: string) => value !== '-' ? <PlatformPropertyCardCopyButtonDecorator value={value}/> : null,
            span: 12,
        }] as PlatformPropertyCardProperty[];

    const {filterAllowed} = useAllowedItems()
    const allowedProperties = filterAllowed(properties) as PlatformPropertyCardProperty[];

    const handleStripeCustomerUpdate = (stripeCustomerId: string) => {
        const updatedCustomer = {
            ...customer,
            billingInfo: {
                ...customer.billingInfo,
                billingProviderRecordId: stripeCustomerId
            }
        };
        setCustomer(updatedCustomer);
        if (onRecordUpdate) {
            onRecordUpdate({
                billingInfo: {
                    ...customer.billingInfo,
                    billingProviderRecordId: stripeCustomerId
                }
            });
        }
    };

    return (
        <Stack gap="md">
            <PlatformPropertyCard properties={allowedProperties}/>
            {customer.billingInfo?.billingProviderId && (
                <StripeCustomerButtons 
                    customer={customer} 
                    onCustomerUpdated={handleStripeCustomerUpdate}
                />
            )}
        </Stack>
    );
};